var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCulturalFitRejectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22959",
    "data-name": "Group 22959",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-cultural-fit-rejection-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3692",
    "data-name": "Rectangle 3692",
    width: 62,
    height: 62,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22959-2",
    "data-name": "Group 22959",
    clipPath: "url(#clip-path-cultural-fit-rejection-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12464",
    "data-name": "Path 12464",
    d: "M251.518,268.371a16.852,16.852,0,1,1,16.852-16.852,16.871,16.871,0,0,1-16.852,16.852m0-31.111a14.259,14.259,0,1,0,14.259,14.259,14.276,14.276,0,0,0-14.259-14.259",
    transform: "translate(-206.147 -206.148)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12465",
    "data-name": "Path 12465",
    d: "M273.612,296.886a1.3,1.3,0,0,1-.918-2.211l21.962-21.959a1.3,1.3,0,0,1,1.833,1.833l-21.962,21.959a1.292,1.292,0,0,1-.915.379",
    transform: "translate(-239.221 -239.239)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12466",
    "data-name": "Path 12466",
    d: "M80.852,301.26H65.3a1.3,1.3,0,1,1,0-2.593H80.852a1.3,1.3,0,1,1,0,2.593",
    transform: "translate(-56.222 -262.37)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12467",
    "data-name": "Path 12467",
    d: "M78.259,365.26H65.3a1.3,1.3,0,0,1,0-2.593H78.259a1.3,1.3,0,1,1,0,2.593",
    transform: "translate(-56.222 -318.593)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12468",
    "data-name": "Path 12468",
    d: "M143.851,74.37a5.185,5.185,0,1,1,5.185-5.185,5.19,5.19,0,0,1-5.185,5.185m0-7.778a2.593,2.593,0,1,0,2.593,2.593,2.6,2.6,0,0,0-2.593-2.593",
    transform: "translate(-121.814 -56.222)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12469",
    "data-name": "Path 12469",
    d: "M115.445,181.037a1.3,1.3,0,0,1-1.3-1.3v-2.593a3.894,3.894,0,0,0-3.889-3.889h-7.778a3.894,3.894,0,0,0-3.889,3.889v2.593a1.3,1.3,0,1,1-2.593,0v-2.593a6.489,6.489,0,0,1,6.481-6.481h7.778a6.489,6.489,0,0,1,6.482,6.481v2.593a1.3,1.3,0,0,1-1.3,1.3",
    transform: "translate(-84.333 -149.926)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12470",
    "data-name": "Path 12470",
    d: "M24.63,54.445H6.482A6.489,6.489,0,0,1,0,47.963V6.481A6.489,6.489,0,0,1,6.482,0H37.593a6.489,6.489,0,0,1,6.481,6.481V22.193a1.3,1.3,0,1,1-2.593,0V6.481a3.894,3.894,0,0,0-3.889-3.889H6.482A3.894,3.894,0,0,0,2.593,6.481V47.963a3.894,3.894,0,0,0,3.889,3.889H24.63a1.3,1.3,0,1,1,0,2.593",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulturalFitRejectionIcon);
export default __webpack_public_path__ + "static/media/cultural-fit-rejection-icon.5b638da3447fc3282098ad7de2220e32.svg";
export { ForwardRef as ReactComponent };